import { useAppDispatch, useAppState } from '@/store';
import { selectPaymentMethodsIsLoading, updatePaymentMethod } from '../feature';

export const useUpdatePaymentMethod = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectPaymentMethodsIsLoading);

  const updatePaymentMethodData = async (id: string, isEnabled: boolean) => {
    await dispatch(
      updatePaymentMethod({
        id,
        enabled: isEnabled,
      }),
    ).unwrap();
  };

  return {
    updatePaymentMethod: updatePaymentMethodData,
    isLoading,
  };
};
